"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarRoutes = void 0;
const component_1 = require("@front/pages/avatar/form/component");
const component_2 = require("@front/pages/avatar/list/component");
const component_3 = require("@front/pages/avatar/preview/component");
const backendImport_1 = require("@front/backendImport");
const component_4 = require("@front/pages/knowledge/project-form/component");
const component_5 = require("@front/pages/knowledge/project-list/component");
const component_6 = require("@front/pages/knowledge/form/component");
const component_7 = require("@front/pages/knowledge/list/component");
const component_8 = require("@front/pages/knowledge/preview/component");
const component_9 = require("@front/pages/ai/jobs/component");
const component_10 = require("@front/pages/knowledge/bulk-upload/component");
const { aclResources, aclActions } = backendImport_1.ACL;
exports.avatarRoutes = [
    {
        path: '/avatar/list',
        name: 'route.avatar.list'.t(),
        component: component_2.AvatarList,
        icon: 'speedometer',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/avatar/form',
        name: 'route.avatar.create'.t(),
        component: component_1.AvatarForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/avatar/form/:id',
        name: 'route.avatar.edit'.t(),
        component: component_1.AvatarForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/avatar/preview/:id',
        name: 'route.avatar.preview'.t(),
        component: component_3.AvatarPreview,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/ai/knowledge/list',
        name: 'route.knowledge.list'.t(),
        component: component_7.KnowledgeList,
        icon: 'book-open',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/ai/training-jobs',
        name: 'training_jobs.list'.t(),
        component: component_9.TrainingJobList,
        icon: 'calendar',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/ai/knowledge/create',
        name: 'route.knowledge.create'.t(),
        component: component_6.KnowledgeForm,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/ai/knowledge/bulk-upload',
        name: 'route.knowledge.bulk_upload'.t(),
        component: component_10.KnowledgeBulkUpload,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/ai/knowledge/edit/:id',
        name: 'route.knowledge.edit'.t(),
        component: component_6.KnowledgeForm,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/ai/knowledge/preview/:id',
        name: 'route.knowledge.preview'.t(),
        component: component_8.KnowledgePreview,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/ai/knowledge/projects',
        name: 'route.knowledgeProject.list'.t(),
        component: component_5.ProjectList,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/ai/knowledge/project/create',
        name: 'route.knowledgeProject.create'.t(),
        component: component_4.ProjectForm,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/ai/knowledge/project/edit/:id',
        name: 'route.knowledgeProject.edit'.t(),
        component: component_4.ProjectForm,
        forceActive: '/ai/knowledge/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.knowledge}.${backendImport_1.ACL.aclActions.write}`
    }
];
